module.exports = __webpack_public_path__ + "img/34_23.e7a4420a.png";